var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1178"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1178"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34756",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};